export enum Language {
    German = 'de-DE',
    English = 'en-US',
    Spanish = 'es-ES',
    French = 'fr-FR',
    Italian = 'it-IT',
    Japanese = 'ja-JP',
    Korean = 'ko-KR',
    Portuguese = 'pt-BR',
    Russian = 'ru-RU',
    Thai = 'th-TH',
    Turkish = 'tr-TR',
    Chinese = 'zh-CN',
    Taiwan = 'zh-TW',
}
